import React, { useContext, useState } from "react";
import { Form, Formik } from "formik";
import * as Yup from "yup";

import { Headline } from "../../components/Headline";
import { SectionContainer } from "../../components/SectionContainer";
import { Image } from "../../components/Image";
import { Button } from "../../components/Button";
import FormField from "../../components/form-components/FormField";
import t from "../../lib/translate";
import { generateClassString as gcs } from "../../lib/helper/generateClassString";

import * as styles from "./cameraFinder.module.less";
import GeneralPageContext from "../../templates/GeneralPageContext";
import { navigate } from "gatsby";
import { ACTIVE_FILTERS_KEY } from "../../lib/hooks/useCameraFilter";

export function CameraFinder({
    data: {
        id,
        anker,
        headline,
        semanticOfHeadline,
        buttonText,
        image,
        background
    }
}) {
    const {
        layout: { showAnchorNavigation },
        stdPages: { pageCameraListing },
        finderApplications,
        finderCategories
    } = useContext(GeneralPageContext);

    async function submitForm({ category, application }) {
        const selectedCategory =
            category !== "none"
                ? finderCategories.find(({ value }) => value === category)
                : {};

        const selectedApplication =
            application !== "none"
                ? finderApplications.find(({ value }) => value === application)
                : {};

        const activeFilter = [
            ...(selectedCategory
                ? [
                      {
                          key: "category",
                          options: [{ value: selectedCategory.value }]
                      }
                  ]
                : []),
            ...(selectedApplication
                ? [{ key: "application", options: [selectedApplication] }]
                : [])
        ];

        if (activeFilter.length) {
            window.sessionStorage.setItem(
                ACTIVE_FILTERS_KEY,
                JSON.stringify(activeFilter)
            );
        } else {
            window.sessionStorage.setItem(
                ACTIVE_FILTERS_KEY,
                JSON.stringify([])
            );
        }

        navigate(pageCameraListing.url);
    }

    return (
        <SectionContainer
            sectionId={anker}
            sectionClass={styles.cameraFinderContentSection}
            containerClass={styles.cameraFinderContainer}
            background={background}
        >
            <div className={image ? styles.headerContainer : null}>
                {image && (
                    <div className={styles.cameraFinderImage}>
                        <Image image={image} />
                    </div>
                )}

                <Headline
                    headlineClass={
                        image ? styles.cameraFinderHeadline : "reducedWidth"
                    }
                    semanticOfHeadline={semanticOfHeadline}
                >
                    {headline}
                </Headline>
            </div>

            <Formik
                initialValues={{
                    cameracategory: "",
                    industriesandapplications: ""
                }}
                validationSchema={Yup.object({
                    cameracategory: Yup.string(),
                    industriesandapplications: Yup.string()
                })}
                onSubmit={submitForm}
            >
                {(props) => (
                    <Form id={id}>
                        <div
                            className={gcs(styles.formBlock, [
                                showAnchorNavigation,
                                styles.anchored
                            ])}
                        >
                            <FormField
                                type="select"
                                name="category"
                                // placeholder={}
                                options={[
                                    {
                                        label: t(
                                            "camera.filter.cameracategory.label"
                                        ),
                                        value: "none"
                                    },
                                    ...finderCategories.map(
                                        ({ label, value }) => {
                                            return {
                                                label,
                                                value
                                            };
                                        }
                                    )
                                ]}
                                onChange={props.handleChange}
                            />

                            <FormField
                                type="select"
                                name="application"
                                placeholder={t(
                                    "camera.filter.industriesandapplications.label"
                                )}
                                options={[
                                    {
                                        label: t(
                                            "camera.filter.industriesandapplications.label"
                                        ),
                                        value: "none"
                                    },
                                    ...finderApplications.map(
                                        ({ label, value }) => {
                                            return {
                                                label,
                                                value
                                            };
                                        }
                                    ).sort(((a, b) => a.label?.localeCompare(b.label)))
                                ]}
                                onChange={props.handleChange}
                            />

                            <Button
                                className={styles.cameraFinderButton}
                                type="cta"
                                htmlType="submit"
                            >
                                {buttonText}
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </SectionContainer>
    );
}
